import {useStableRandom} from '@github-ui/use-stable-random'
import {Stack} from '@primer/react'
import {LoadingSkeleton} from '@github-ui/skeleton/LoadingSkeleton'
import styles from './MiniMergeSections.module.css'
import {MiniMergeStatusItem} from './MiniMergeStatusItem'

export function MiniMergeStatusSkeleton() {
  const phraseIndex = useStableRandom({min: 0, max: LOADING_PHRASES.length - 1})
  const phrase = LOADING_PHRASES[phraseIndex]

  return (
    <section aria-label="Merge status">
      <Stack
        direction={{narrow: 'vertical', regular: 'horizontal'}}
        className={styles.MiniOverviewMergeStatus}
        gap="none"
        aria-hidden="true"
      >
        <MiniStatusSkeletonItem text={phrase} />
        <MiniStatusSkeletonItem />
      </Stack>
    </section>
  )
}

function MiniStatusSkeletonItem({text}: {text?: string}) {
  return (
    <MiniMergeStatusItem aria-label="Loading merge status">
      <MiniMergeStatusItem.LabelRow>
        <span className="d-flex flex-items-center gap-1">
          {text ? (
            <MiniMergeStatusItem.Label>{text}</MiniMergeStatusItem.Label>
          ) : (
            <LoadingSkeleton variant="text" width="80px" />
          )}
        </span>
        <LoadingSkeleton variant="rounded" width="20px" height="20px" className={styles.MiniStatusLoadingIcon} />
      </MiniMergeStatusItem.LabelRow>
      <LoadingSkeleton className={styles.MiniStatusProgress} variant="rounded" height="8px" />
    </MiniMergeStatusItem>
  )
}

const LOADING_PHRASES = [
  "Deserializing your pull request's destiny…",
  'git blame-ing the delay…',
  'Traversing the commit graph…',
  'Reticulating CI pipelines…',
  'Garbage collecting stale opinions…',
  'Checking if the dog ate your approvals…',
  "Waiting for Schrödinger's CI to collapse into a state…",
  'Begging the automerge daemon for a straight answer…',
  'Asking git log --oneline for the meaning of life…',
  'Checking out your fate on a detached HEAD…',
]
